import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SMALL, MEDIUM} from '../../helpers/IconSize';
import './DestinationMessage.less';
import {getIconProps} from '../../helpers/helpers';

const CLASS_PREFIX = 'DestinationMessage__message';

class DestinationMessage extends Component {
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        destinationMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTitleText: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string
                })
            }),
            PropTypes.shape({
                iconTitleTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string
                })
            }),
            PropTypes.shape({
                iconTitleTextV3: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string
                })
            }),
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                })
            }),
            PropTypes.shape({
                iconText: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                })
            })
        ]),
        color: PropTypes.bool,
        ariaHidden: PropTypes.bool
    };

    static defaultProps = {
        className: '',
        size: MEDIUM,
        destinationMessage: {},
        color: false,
        ariaHidden: false
    };

    // eslint-disable-next-line complexity
    render() {
        const {className, size, destinationMessage, color, ariaHidden} = this.props;
        const {iconText, iconTextV1, iconTitleText, iconTitleTextV1, iconTitleTextV3} = destinationMessage || {};

        if (!iconTitleTextV1 && !iconTitleTextV3 && !iconTextV1 && !iconText && !iconTitleText) {
            return null;
        }
        const {icon, message, title} = iconText || iconTextV1 || iconTitleText || iconTitleTextV3 || iconTitleTextV1;

        const {style, src} = getIconProps(icon, size, color);
        const smallPrefix = size === SMALL ? '--s' : '';

        return (
            <div className={`DestinationMessage ${className}`} aria-hidden={ariaHidden}>
                <div className={`DestinationMessage__img--${size}`}>
                    <img style={style} src={src} alt={icon} />
                </div>
                <div className={`${CLASS_PREFIX}${smallPrefix}`}>
                    {
                        title &&
                        <span className={`${CLASS_PREFIX}${smallPrefix}__title`}><strong>{title}</strong></span>
                    }
                    <span className={`${CLASS_PREFIX}${smallPrefix}__text`}>
                        {message}
                    </span>
                </div>
            </div>
        );
    }
}

export default DestinationMessage;
